export default "__VITE_ASSET__CSt2zZvP__"